import InternalLink from "../components/InternalLink";

export default function SecurityDashboardCard({ title, icon, metric, metricLabel, status, statusColor, linkTo, isLite, upgradeMessage }) {
    return (
        <div className="border rounded-lg p-4 space-y-3 bg-card">
            <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                    <span className="text-lg">{icon}</span>
                    <h3 className="text-sm font-medium">{title}</h3>
                </div>
                {isLite && (
                    <span className="text-[10px] font-medium bg-amber-100 text-amber-700 px-1.5 py-0.5 rounded">LITE</span>
                )}
            </div>
            <div>
                <div className="text-2xl font-bold">{metric ?? "--"}</div>
                {metricLabel && <p className="text-xs text-muted-foreground">{metricLabel}</p>}
            </div>
            <div className="flex items-center justify-between">
                <span className={`text-xs font-medium ${statusColor || "text-muted-foreground"}`}>{status}</span>
                {linkTo && (
                    <InternalLink to={linkTo} className="text-xs text-blue-600 hover:underline">
                        View details
                    </InternalLink>
                )}
            </div>
            {upgradeMessage && (
                <p className="text-xs text-amber-600 border-t pt-2">{upgradeMessage}</p>
            )}
        </div>
    );
}
